// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XXR-","right":"styles_right___5IRR"};